<form [formGroup]="parent" class="logintab" (ngSubmit)="loginClick()">
    <div formGroupName="forbrugerNrGroup" class="login-group-wrapper">
        <div>
            <mat-form-field fxLayout="column">
                <input
                    matInput
                    #forbrugerNrInput
                    placeholder="Forbrugernummer"
                    formControlName="forbrugerNr"
                    id="forbrugerNr"
                    required
                    (keypress)="onForbrugernummerKeypress($event)"
                />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field fxLayout="column">
                <input matInput type="password" placeholder="Kode (4 cifre)" formControlName="kode" id="kode" required />
            </mat-form-field>
        </div>
    </div>
    <div>
        <mat-checkbox formControlName="huskMig" id="huskmig">Husk mig</mat-checkbox>
    </div>
    @if (fejlBesked) {
        <div class="fejlBesked">
            {{ fejlBesked }}
        </div>
    }
    <div class="log-ind-flex" fxLayoutAlign="end start">
        <button mat-flat-button color="primary" type="submit" id="login">Log ind</button>
        <ng-container *ngTemplateOutlet="biometricTemplate"></ng-container>
    </div>
    <div class="linkMargin">
        <a href="javascript:void(0);" (click)="loginHjaelpClick()">Hvor finder jeg mine loginoplysninger?</a>
    </div>
</form>
